export default __webpack_public_path__ + "static/media/bmw.91e45e30.svg";